export default __webpack_public_path__ + "static/media/User.32d85cb8.svg";